export default __webpack_public_path__ + "static/media/visa.5e9e3ea5.svg";